import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { JourgemachineService } from '../services/jourgemachine.service';
// @ts-ignore
import ApexCharts  from 'apexcharts';
import pdfMake from 'pdfmake/build/pdfmake';
import { style } from '@angular/animations';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
@Component({
  selector: 'app-jourgemachinedashboard',
  templateUrl: './jourgemachinedashboard.component.html',
  styleUrls: ['./jourgemachinedashboard.component.scss']
})
export class JourgemachinedashboardComponent implements OnInit {
  @ViewChild('dialogTemplate',{ static: true }) dialogTemplate!: TemplateRef<any>;
  deviceList: any= [];

  isTotalUtilization = false;
  latestData: any;
  status:any = '';
  operationalHour:any = 0;
  operationalMinute:any = 0;
  operationalSeconds:any= 0;
  statusArray = ['working','maintenance','quality','fault','setup','off'];
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  operationalEfficiencyScore;
  utilizationsRate: any;
  qualityRate: any;
  downtimeRate: any;
  utilization: any;
  workingPercentage: any;
  setupPercentage: any;
  qualityPercentage: any;
  maintenancePercentage: any;
  offPercentage: any;
  faultPercentage:any;
  heading: any=[];
  dataSource;
  timeFilter;
  workingtimeFilter;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  isReport: boolean = false;
  isWorkingDuration: boolean = false;
  workingChartData: any;
  filter: any = {};
  customeSelectedDate:any;
  dialogDataSource: MatTableDataSource<unknown>;
  reportdata: any;
  workingchart: any;
  todaysoperationalHour: number;
  todaysoperationalSeconds: number;
  todaysoperationalMinute: number;
  selectedDevice: any;
  utilizationchart: any;
  operatoinalEfficiencychart: any;

  constructor(private JourgemachineService: JourgemachineService,private dialog: MatDialog,private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.timeFilter = 'Today';
    this.workingtimeFilter = 'This Week';
    //this.getDaywiseDATA({"filter":"This Week"},"workingChart")
    this.getReport({"filter":"Today"});
    this.filters('date', 'Today');
    this.getDeviceIDS();
    setInterval(() => {
      this.getData();
    }, 10000);
    setTimeout(()=>{
      this.utilizationRate(null,"chart")
      this.operationEfficiencyScore()
    },10)
    setTimeout(()=>{
      
      this.getDataFromDatabase();
      

  },100)
  }
  getDeviceData(device:any){
    this.selectedDevice = device;
    this.getDataFromDatabase();
    //this.getDaywiseDATA(this.filter,"workingChart1");
    this.getReport(this.filter);
  }
  getDeviceIDS(){
    this.JourgemachineService.getDeviceIDS().subscribe((data:any) => {
      if(data.status){
        console.log(data.data)
        this.deviceList = data.data;
        this.selectedDevice = this.deviceList[0].deviceid
      }
    });
  }
  getDataFromDatabase(){
    console.log("selected device ",this.selectedDevice)
    this.JourgemachineService.getMachineData({deviceid:this.selectedDevice}).subscribe((data:any) => {
      if(data.code == 1){
       delete data.data[0].id;
        this.latestData = data.data[0];
        console.log("is this data",this.latestData.deviceid.toUpperCase(),this.selectedDevice)

        if (this.latestData.deviceid.toUpperCase() == this.selectedDevice.toUpperCase()){
          console.log("inside if")
          this.status = Object.entries(this.latestData).slice(0, 8)
          .filter(([key, value]) =>  value == 1)
          .map(([key]) => key);
        }
        console.log("this.status",Object.entries(this.latestData).slice(0, 7))
     // this.calculateOperationalTime(data.data[0]);
     // this.utilizationRate(data.data[0],"chart")
     this.updateUtilizationRate(data.data[0]);
      this.updateoperationalEfficiency(data.data[0]);
      this.statusArray = this.statusArray.filter(status => status !== this.status[0]);
      console.log("/////////////",this.statusArray);

      }
    });
  }
getData(){
  this.JourgemachineService.listenForUpdates().subscribe((data:any) => {
    console.log(data);  
    if(data.code == 1){
      this.latestData = data.data;
      console.log("what is inside",data.data)
      if (this.latestData.device_id.toUpperCase() == this.selectedDevice.toUpperCase()){
        this.status = Object.entries(this.latestData)
          .slice(0, 7)
          .filter(([key, value]) => value == 1)
          .map(([key]) => key);
      }
      
      //this.calculateOperationalTime(data.data);
      this.statusArray = ['working','maintenance','quality','fault','setup','off']
      this.statusArray = this.statusArray.filter(status => status !== this.status[0]);
    }
  });
}
calculateOperationalTime(data){
  let totalTime = Number(data.workingDuration) +  Number(data.qualityDuration) + Number(data.setupDuration);
  this.operationalHour = Number(Math.floor(totalTime / 60)); // Extract hours
this.operationalMinute = Number(totalTime % 60); // Extract remaining minutes
 this.operationalSeconds = Number(String(Math.round((totalTime % 1) * 60)).padStart(1, '0'));
 let durationSum = this.reportdata
  .filter((value: any) => 
    value.Machine_state == "working" || 
    value.Machine_state == "setup" || 
    value.Machine_state == "quality"
  )
  .reduce((sum: number, value: any) => sum + Number(value.Duration || 0), 0);

  this.todaysoperationalHour = Number(Math.floor(durationSum / 60)); // Extract hours
this.todaysoperationalMinute = Number(durationSum % 60); // Extract remaining minutes
 this.todaysoperationalSeconds = Number(String(Math.round((durationSum % 1) * 60)).padStart(2, '0'));
if(this.reportdata[this.reportdata.length-1].Machine_state == "working" || this.reportdata[this.reportdata.length-1].Machine_state == "setup" || this.reportdata[this.reportdata.length-1].Machine_state == "quality"){
  
  let latestTimeDiff = this.reportdata[this.reportdata.length-1].diffTime
  let latestoperationalHour = Number(Math.floor(latestTimeDiff / 60)); // Extract hours
  let latestoperationalMinute = Number(latestTimeDiff % 60); // Extract remaining minutes
   let latestoperationalSeconds = Number(String(Math.round((latestTimeDiff % 1) * 60)).padStart(2, '0'));
   this.operationalHour +=latestoperationalHour;
   this.operationalMinute += latestoperationalMinute;
   this.todaysoperationalHour += latestoperationalHour;
   this.todaysoperationalMinute += latestoperationalMinute;
   if (this.todaysoperationalMinute >= 60) {
    this.todaysoperationalHour += Math.floor(this.todaysoperationalHour / 60); // Add overflow minutes as hours
    this.todaysoperationalMinute = this.todaysoperationalMinute % 60; // Keep remaining minutes
  }
  if (this.operationalMinute >= 60) {
    this.operationalHour += Math.floor(this.operationalMinute / 60); // Add overflow minutes as hours
    this.operationalMinute = this.operationalMinute % 60; // Keep remaining minutes
  }


// Start the timer
/*setInterval(() => {
  this.operationalSeconds += 1; // Increment seconds
  this.todaysoperationalSeconds += 1;
  // Handle overflow of seconds into minutes
  if (this.operationalSeconds === 60) {
    this.operationalSeconds = 0;
    this.operationalMinute += 1;
  }
  if (this.todaysoperationalSeconds === 60) {
    this.todaysoperationalSeconds = 0;
    this.todaysoperationalMinute += 1;
  }

  // Handle overflow of minutes into hours
  if (this.operationalMinute === 60) {
    this.operationalMinute = 0;
    this.operationalHour += 1;
  }
  if (this.todaysoperationalMinute === 60) {
    this.todaysoperationalMinute = 0;
    this.todaysoperationalHour += 1;
  }

}, 1000);*/
}
}
utilizationRate(data,domID){
  var options = {
    series: [
      {
        data: [
          Number(0),
          Number(0),
          Number(0),
          Number(),
          Number(),
          Number()
        ]
      }
    ],
    chart: {
      type: 'bar',
      height: "90%",
      toolbar: {
        show: false
      }
    },
    colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#FFFF00'],
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
        distributed: true, 
      }
    },
    dataLabels: {
      enabled: true, 
      style: {
        colors: ['#FFFFFF'],
        fontSize: '1.5vh', 
      },
      offsetX: 20, 
    position: 'right',
      formatter: function (val) {
        let hours =  Number(Math.floor(val / 60)); 
        let minute = Number(val%60);
        return `${hours}:${minute}`; 
      }
    },
    xaxis: {
      categories: [
        'Working',
        'Off',
        'Maintenance',
        'Setup',
        'Fault',
        'Quality'
      ],
      
      labels: {
        style: {
          colors: '#FFFFFF', 
          fontSize: '1.5vh',
         
        }
      }
    },
    yaxis: {
      title: {
        text: 'Machine State', 
        style: {
          fontSize: '1.5vh',
          fontWeight: 'bold',
          color: '#FFFFFF'
        }
      },
      labels: {
        style: {
          colors: ['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#FFFF00'],
          fontSize: '2vh',
          fontWeight: 'bold'
        }
      }
    },
    grid: {
      show: false 
    },
    legend: {
      show: false 
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          const yLabels = [
            'Working Duration',
            'Off Duration',
            'Maintenance Duration',
            'Setup Duration',
            'Fault Duration',
            'Quality Duration'
          ];
          const seriesIndex = opts.seriesIndex; // Current series index
          const dataPointIndex = opts.dataPointIndex; // Current data point index
          return `${yLabels[dataPointIndex]}: ${val} Seconds`;
        }
      },
      theme: 'dark' // Sets a dark theme for better visibility
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: "100%" 
          },
          plotOptions: {
            bar: {
              horizontal: false 
            }
          }
        }
      }
    ]
  };
  
  
  this.utilizationchart = new ApexCharts(document.querySelector("#"+domID), options);
  this.utilizationchart.render();
}
updateUtilizationRate(newData) {
  if (this.utilizationchart) {
    const dataArray = [
      Number(newData.workingDuration || 0),
      Number(newData.offDuration || 0),
      Number(newData.maintenanceDuration || 0),
      Number(newData.setupDuration || 0),
      Number(newData.faultDuration || 0),
      Number(newData.qualityDuration || 0)
    ];

    this.utilizationchart.updateOptions({
      series: [{
        data: dataArray
      }]
    });
  }
}

workingChart(data,id){

  let day = Array.from(new Set(data.map((data: any) => data.date)));
  let working = day.map((date: string) => {
      let totalDuration = data
          .filter((entry: any) => entry.date === date && entry.machinestate === "working")
          .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
          return totalDuration;
  });   
  let off = day.map((date: string) => {
    let totalDuration = data
        .filter((entry: any) => entry.date === date && entry.machinestate === "off")
        .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
        return totalDuration ;
});
let setup = day.map((date: string) => {
  let totalDuration = data
      .filter((entry: any) => entry.date === date && entry.machinestate === "setup")
      .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
      return totalDuration;
});
let quality = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "quality")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration;
});
let fault = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "fault")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration ;
});
let maintenance = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "maintenance")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration;
});


  var options = {
    series: [{
      name: 'Working',
      data: working
    }, {
      name: 'Off',
      data: off
    },{
      name: 'Maintenance',
      data: maintenance
    },{
      name: 'Setup',
      data: setup
    },{
      name: 'Fault',
      data: fault
    },{
      name: 'Quality',
      data: quality
    }],
    colors:['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#ffdf80'],
    chart: {
      type: 'area',
      height: "100%",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 1,
        borderRadiusApplication: 'end',
      }
    },
    stroke: {
      curve: 'smooth',
      width: 0.9
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories:day,
      title: {
        text: 'Date Of Current Month', 
        style: {
          fontSize: '1.5vh',
          fontWeight: 'bold',
          color: '#FFFFFF'
        }
      },
      labels: {
        style: {
          colors: '#FFFFFF', 
          fontSize: '1.5vh',
         
        }
      }
    },
    yaxis:{
      title: {
        text: 'Time In Hours', 
        style: {
          fontSize: '1.5vh',
          fontWeight: 'bold',
          color: '#FFFFFF'
        }
      },
      labels: {
        style: {
          colors: '#FFFFFF', 
          fontSize: '1.5vh',
         
        }
      }
    },
    legend:{
      labels: {
        colors: '#FFFFFF',
        style:{
          fontSize: '1.5vh'
        } 
      },
      position: 'top',
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          
          const seriesIndex = opts.seriesIndex; // Current series index
          const dataPointIndex = opts.dataPointIndex; // Current data point index
          return ` ${val} Minute`;
        }
      },
      theme: 'dark' // Sets a dark theme for better visibility
    },
    grid: {
      show: false  
    }
  };
  
  let chart = new ApexCharts(document.querySelector("#"+id), options);
  chart.render();
  
}
async popupworkingChart(data,id){
 if(this.workingchart){
  await  this.workingchart.destroy();
}
  let day = Array.from(new Set(data.map((data: any) => data.date)));
  let working = day.map((date: string) => {
      let totalDuration = data
          .filter((entry: any) => entry.date === date && entry.machinestate === "working")
          .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
          return totalDuration;
  });   
  let off = day.map((date: string) => {
    let totalDuration = data
        .filter((entry: any) => entry.date === date && entry.machinestate === "off")
        .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
        return totalDuration ;
});
let setup = day.map((date: string) => {
  let totalDuration = data
      .filter((entry: any) => entry.date === date && entry.machinestate === "setup")
      .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
      return totalDuration;
});
let quality = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "quality")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration;
});
let fault = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "fault")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration ;
});
let maintenance = day.map((date: string) => {
let totalDuration = data
    .filter((entry: any) => entry.date === date && entry.machinestate === "maintenance")
    .reduce((sum: number, entry: any) => sum + Number(entry.duration), 0);
    return totalDuration;
});
let graphType="area"
if(day.length < 2){
  graphType = "bar";
}

  var options = {
    series: [{
      name: 'Working',
      data: working
    }, {
      name: 'Off',
      data: off
    },{
      name: 'Maintenance',
      data: maintenance
    },{
      name: 'Setup',
      data: setup
    },{
      name: 'Fault',
      data: fault
    },{
      name: 'Quality',
      data: quality
    }],
    colors:['#32CD32', '#7F7F7F', '#FFA500', '#0000FF', '#FF0000', '#ffdf80'],
    chart: {
      type: graphType,
      height: "100%",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 1,
        borderRadiusApplication: 'end',
      }
    },
    stroke: {
      curve: 'smooth',
      width: 0.9
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories:day,
      title: {
        text: 'Date Of Current Month', 
        style: {
          fontSize: '1.5vh',
          fontWeight: 'bold',
          
        }
      },
      labels: {
        style: {
         
          fontSize: '1.5vh',
         
        }
      }
    },
    yaxis:{
      title: {
        text: 'Time In Hours', 
        style: {
          fontSize: '1.5vh',
          fontWeight: 'bold',
         
        }
      },
      labels: {
        style: {
          
          fontSize: '1.5vh',
         
        }
      }
    },
    legend:{
      labels: {
        
        style:{
          fontSize: '1.5vh'
        } 
      },
      position: 'top',
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          
          const seriesIndex = opts.seriesIndex; // Current series index
          const dataPointIndex = opts.dataPointIndex; // Current data point index
          return ` ${val} Minute`;
        }
      },
      theme: 'dark' // Sets a dark theme for better visibility
    },
    grid: {
      show: false  
    }
  };
  
  this.workingchart = new ApexCharts(document.querySelector("#"+id), options);
  this.workingchart.render();
  
}
operationEfficiencyScore(){

var options = {
  series: [0],
  chart: {
    height: '90%',
  padding:0,
  type: 'radialBar',
  offsetY: 0
},
plotOptions: {
  radialBar: {
    startAngle: -160,
    endAngle: 160,
    dataLabels: {
      name: {
        fontSize: '1.5vh',
        color: '#964B00',
        offsetY: '-5%'
      },
      value: {
        offsetY: 0,
        fontSize: '2vh',
        color: '#FFFFFF',
        formatter: function (val) {
          return val + " %";
        }
      }
    }
  }
},
fill: {
  colors: ['#0B5345'], // Red for values 60 and above
  type: 'gradient',
  gradient: {
      shade: 'dark',
      shadeIntensity:1,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.1,
      //stops: [0, 50, 65, 91]
  },
  
},
stroke: {
  dashArray: 5
},
labels: ['Score %'],
grid: {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}
};

this.operatoinalEfficiencychart = new ApexCharts(document.querySelector("#operatoinalEfficiency"), options);
this.operatoinalEfficiencychart.render();

}
updateoperationalEfficiency(data:any){
  let totalOperationalTime = Number(data.offDuration)+Number(data.qualityDuration)+Number(data.faultDuration)+Number(data.workingDuration)+
                           Number(data.setupDuration)+Number(data.maintenanceDuration);
this.utilizationsRate = Number(((Number(data.workingDuration)+Number(data.setupDuration))/totalOperationalTime)*100).toFixed(2);
 this.qualityRate = Number(Number(data.qualityDuration/totalOperationalTime)*100).toFixed(2);
 this.utilization = (Number(this.utilizationsRate) + Number(this.qualityRate)).toFixed(2);
 this.downtimeRate = Number((Number(Number(data.offDuration)+Number(data.faultDuration)+Number(data.maintenanceDuration))/totalOperationalTime)*100).toFixed(2);
this.operationalEfficiencyScore = Number(Number(this.utilizationsRate)+Number(this.qualityRate)-Number(this.downtimeRate)).toFixed(2);
this.workingPercentage = ((Number(data.workingDuration)/totalOperationalTime)*100).toFixed(2);
this.setupPercentage = ((Number(data.setupDuration)/totalOperationalTime)*100).toFixed(2);
this.qualityPercentage = ((Number(data.qualityDuration)/totalOperationalTime)*100).toFixed(2);
this.maintenancePercentage = ((Number(data.maintenanceDuration)/totalOperationalTime)*100).toFixed(2);
this.offPercentage  = ((Number(data.offDuration)/totalOperationalTime)*100).toFixed(2);
this.faultPercentage  = ((Number(data.faultDuration)/totalOperationalTime)*100).toFixed(2);

if (this.operatoinalEfficiencychart) {
  this.operatoinalEfficiencychart.updateOptions({
    series: [Number(this.operationalEfficiencyScore)]
  });
}
}
getDaywiseDATA(data,id){
  data.deviceid = this.selectedDevice;
  this.JourgemachineService.getGeorgMachineWorkingReport(data).subscribe((data:any) => {
   console.log("what is data",data)
   if(id == "workingChart" ){
    this.workingChartData = data.data;
    this.workingChart(data.data,id)
   } else {
    this.popupworkingChart(data.data,id)
   }
  });
  
}
getReport(data){
  console.log("what is yesterdays data",data)
  data.device = this.selectedDevice;
  this.JourgemachineService.getGeorgMachineReport(data).subscribe((data:any) => {
    console.log("report data",data)
    if(data.data.length>0){
    this.heading = Object.keys(data.data[0])
    this.heading.pop();
    this.reportdata = data.data;
    this.dataSource = new MatTableDataSource(data.data);
    this.dialogDataSource = new MatTableDataSource(data.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    }
    
   });
}
  async openPopup(selected): Promise<void> {
  
  if (this.dialogTemplate) {
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      width: '70%',
      height:'70%', 
      panelClass: 'custom-dialog', 
    });
   if(selected == "totalUtilization"){
    this.isWorkingDuration = false;
    this.isReport = false;
     this.isTotalUtilization = await true;
    
    dialogRef.afterOpened().subscribe(() => {
      this.utilizationRate(this.latestData,"utilizationChart");
    });
   } else if(selected == "report"){ 
    this.isTotalUtilization = false
    this.isWorkingDuration = false;
      this.isReport = true;
      
      
   } else if(selected == "workingDuration"){
    this.isReport = false;
    this.isTotalUtilization = false;
     this.isWorkingDuration = true;
     dialogRef.afterOpened().subscribe(() => {
      this.popupworkingChart(this.workingChartData,"workingChart1")    });
     
   }
   
}
}
async filters(type: string, param: string) {
  
          this.timeFilter = param;
          this.workingtimeFilter = param;
        //  if (Object.keys(this.filter).length > 0) {

              var filter: any = await this.formatDate(param);
              //this.filter = this.filter + filter;
              if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
                  if (this.filter && this.filter.date) {
                      delete this.filter.date;
                  }
                  this.filter.startDate = filter.startDate;
                  this.filter.endDate = filter.endDate;
                  this.filter.filter = filter.filter;
              }
              else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
                  if (this.filter && this.filter.startDate && this.filter.endDate) {
                      delete this.filter.startDate;
                      delete this.filter.endDate;
                  }
                  this.filter.filter = filter.filter
                  this.filter.date = filter.date;
                 
              }

              else if (filter.filter === 'Custom') {
                  if (this.filter && this.filter.date) {
                      delete this.filter.date;
                  }
                  if(filter.startDate && filter.endDate) {
                      this.filter.startDate = filter.startDate;
                  this.filter.endDate = filter.endDate;
                  this.filter.filter = filter.filter;
                  }

              }
          
            
              
                  this.getReport(this.filter);
                
                  
              
              //this.filter = this.filter + '&' + `date=${date}` + '&' + `filter=${param}`;
        //  }


      } 
    formatDate(param) {
      return new Promise((resolve, reject) => {
          if (param === 'Today') {
              var d = new Date(),
                  month = '' + (d.getMonth() + 1),
                  day = '' + d.getDate(),
                  year = d.getFullYear();

              if (month.length < 2)
                  month = '0' + month;
              if (day.length < 2)
                  day = '0' + day;
              resolve({ 'date': [year, month, day].join('-'), 'filter': param })
              // return [year, month, day].join('-');
          } else if (param === 'Yesterday') {     
              const date = new Date();
              date.setDate(date.getDate() - 1); // Subtract one day from the current date
              
              const year = date.getFullYear();
              const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
              const day = ('0' + date.getDate()).slice(-2); // Add leading zero if needed

              let yesterday = `${year}-${month}-${day}`;
              resolve({ 'date':yesterday, 'filter': param });
              //return [year, month, day].join('-');
          } else if (param === 'Last Month') {
              resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param })
              // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
              // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
          }
          else if (param === 'This Month') {
              resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
              // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);

          } else if (param === 'This Week') {
              resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param })
              //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
          }
          else if (param === 'Custom') {
              const dialogConfig = new MatDialogConfig();
              let dialogRef = this.dialog.open(CustomDateComponent, {
                  autoFocus: false,
                  height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
              });


              dialogRef.afterClosed().subscribe(value => {
                  console.log("Value=======",value);
                  this.customeSelectedDate=value;
                  resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param })
              });
          }
      })
  }
}
